














import ButtonWithContext from "@share/web-conferences/components/common/ButtonWithContext.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import Devices from "./Devices.vue";
import GearIcon from "../../../../assets/svg/web-conferences/gear.svg";
import { LiveKitClientInterface } from "@share/live-kit/interfaces/LiveKitClientInterface";

@Component({
  name: "DeviceButton",
  components: {Devices, ButtonWithContext, GearIcon}
})
export default class DeviceButton extends Vue {
  @Prop({ required: true }) stateKey: string;
  @Prop({ default: false }) isRound: boolean;
  @Prop({ required: true}) client: LiveKitClientInterface;

  onDevicesChanges(devices: MediaDeviceInfo[]) {
    this.$emit('devicesChanged', devices);
  }
}
